module.exports = __webpack_public_path__ + "static/media/파.da585a1e.jpg";